import FirebaseRead from "@/services/database/firebaseRead";
import store from "@/store/store";
import TimeStamp from "@/services/timeStamp";
import SPIELER_MEMBERSHIP_HANDLER from "@/services/data/spieler/spielerMembershipHandler";
import {CloudStorageHandler} from "@/services/storage/cloudStorageHandler";
import FirebaseWrite from "@/services/database/firebaseWrite";

export class MassDeleteService {
    constructor() {
        this.inaktiveSpieler = [];
        this.deleteableSpieler = [];
        this.lastSportTagLimit = this.getLastSportTagLimit()
        this.inProgress = false;
        this.progress = {
            total: 0,
            deleted: 0
        }
    }

    setProgress(inProgress, progressTotal, progressDeleted){
        this.inProgress = inProgress;
        setTimeout(()=> {
            this.progress.total = progressTotal
            this.progress.deleted = progressDeleted
        }, 200)

    }
    getProgress(){
        return ( this.progress.deleted / this.progress.total ) * 100
    }

    async loadInaktiveSpieler(){
        const inaktiveSpieler = await FirebaseRead.readDocList('spieler',
            {field: 'dates.lastSportTag', operator: '<=', value: this.lastSportTagLimit}
        )
        this.inaktiveSpieler = inaktiveSpieler.filter(spieler => spieler.status === 'inaktiv')
        this.setDeleteableSpieler();
    }

    setDeleteableSpieler(){
        const todayString = TimeStamp.getTodayString()
        this.deleteableSpieler = this.inaktiveSpieler.map( spieler => ({
            ...spieler,
            selected: false,
            activeRoles: this.hasActiveRoles(spieler.roles, todayString),
            geschlechtLang: spieler.geschlecht === 'm' ? 'männlich' : 'weiblich',
            inaktivSeit: TimeStamp.getStringDotDateFromString(spieler.dates.lastSportTag),
            lastMembership: SPIELER_MEMBERSHIP_HANDLER.getLastRegularMembership(spieler.memberships),
        }))
    }

    getLastSportTagLimit(){
        const currentLastSportTag = store.state.local.sportJahr.current.until
        const currentYear = currentLastSportTag.substring(0,4)
        const limitYear = parseInt(currentYear) - 4
        return currentLastSportTag.replace(currentYear, limitYear)
    }

    hasActiveRoles(roles, todayString){
        if ( !roles ) { return '-' }
        const aktiveRoles = []
        Object.keys(roles).forEach( (roleKey) => {
            if ( roleKey !== 'isSchiedsrichter' && roleKey !== 'isTrainer' ) {
                const role = roles[roleKey]
                if ( role.bis >= todayString ) {
                    aktiveRoles.push(roleKey.toUpperCase())
                }
            }
        });
        return aktiveRoles.length === 0 ? '-' : aktiveRoles.join(', ')
    }

    setSelected(to){
        const listTemp = JSON.parse(JSON.stringify(this.deleteableSpieler))
        listTemp.forEach( (spieler) => {
            if ( spieler.activeRoles === '-' ) spieler.selected = to
        });
        this.deleteableSpieler = listTemp
    }

    getNumberOfSelectedForDelete(){
        return this.deleteableSpieler.filter(spieler => spieler.selected).length;
    }

    async deleteSelected(){
        let promiseList = []
        const deleteableSpieler = this.deleteableSpieler.filter(spieler => spieler.selected)
        if ( deleteableSpieler.length === 0 ) return
        this.setProgress(true, deleteableSpieler.length, 0)
        for ( let i = 0; i < deleteableSpieler.length; i++ ) {
            const spieler = deleteableSpieler[i]
            promiseList = await this.deleteSpieler(spieler, promiseList)
            if ( i % 2 === 0 && i > 0 ) {
                await Promise.all(promiseList)
                promiseList = []
                this.progress.deleted = i
            }
        }
        if ( promiseList.length > 0 ) {
            await Promise.all(promiseList)
            this.progress.deleted = deleteableSpieler.length
        }
        await this.loadInaktiveSpieler()
        this.setProgress(false, 0, 0)
    }
        async deleteSpieler(spieler, promiseList){
        // delete image
            this.deleteSpielerImage(spieler)
        // delete spieler actions
            promiseList = await this.deleteSpielerActions(spieler, promiseList)
        // delete spieler kugeln
            promiseList = await this.deleteSpielerKugeln(spieler, promiseList)
        // delete spieler
            promiseList.push(FirebaseWrite.delete('spieler', spieler.id))
        // delete spieler private
            promiseList.push(FirebaseWrite.delete('spieler/' + spieler.id + '/private', spieler.id))
            return promiseList
        }

            deleteSpielerImage(spieler){
                if ( spieler.url ) {
                    const cloudStorageHandler = new CloudStorageHandler();
                    cloudStorageHandler.deleteFile('/passfotos/' + spieler.id + '.jpeg')
                }
            }

            async deleteSpielerActions(spieler, promiseList){
                const spielerActions = await FirebaseRead.readDocList('spieler_actions', {
                    field: 'search_spieler', operator: '==', value: spieler.id
                })
                spielerActions.forEach( (spielerAction) => {
                    promiseList.push(FirebaseWrite.delete('spieler_actions', spielerAction.id))
                });
                return promiseList
            }

            async deleteSpielerKugeln(spieler, promiseList){
                const spielerKugeln = await FirebaseRead.readDocList('kugeln', {
                    field: 'ownerId', operator: '==', value: spieler.id
                })
                spielerKugeln.forEach( (kugel) => {
                    promiseList.push(FirebaseWrite.delete('kugeln', kugel.id))
                });
                return promiseList
            }
}